// Material UI
import { makeStyles } from '@material-ui/core'
// Colors
import Colors from '../../../../constants/Colors'

export default makeStyles({
  button: {},
  icon: {
    backgroundColor: Colors.PRIMARY_COLOR,
    border: 'none',
    borderRadius: '50%',
    color: Colors.WHITE,
    height: 20,
    width: 20,
  },
  iconDisabled: {
    backgroundColor: Colors.BACKGROUND_COLOR_LIGHT,
    color: Colors.DISABLED_COLOR,
  },
  label: {
    paddingRight: 4,
    paddingLeft: 4,
  },
})
